// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d70fbe2","453":"283c81b6","455":"52802017"}[chunkId] + ".chunk.js";
};